//GeneratorFlag:[NoChange]
import Feature from './feature';
import FeatureGroup from './feature-group';
import FeatureInputType from './feature-input-type';

export default {Feature, FeatureGroup, FeatureInputType}
export{Feature, FeatureGroup, FeatureInputType}